import { FEATURE_TOGGLES, useFeatureContext } from 'App/components/FeatureProvider/FeatureProvider';
import { useMemo } from 'react';

const useFeatureToggle = nameOrFunction => {
  const { features } = useFeatureContext();
  return useMemo(() => {
    if (typeof nameOrFunction === 'function') {
      return features[nameOrFunction(FEATURE_TOGGLES)];
    }
    return features[nameOrFunction];
    // biome-ignore lint/correctness/useExhaustiveDependencies: nameOrFunction doesn't always change
  }, [features, nameOrFunction]);
};

export const useFeatureToggles = () => {
  const { features } = useFeatureContext();
  return features;
};

export default useFeatureToggle;
